import React from 'react'

function CobroCoactivoScreen() {
  return (
    <div>CobroCoactivoScreen</div>
  )
}

export default CobroCoactivoScreen